import * as React from 'react';
import * as styles from './styles.css';
import { Header3, Paragraph3 } from '@cian/ui-kit/typography';
import { trackHelpDealRentTrapClick } from './tracking';

export const DealRentBanner: React.FC = () => {
  return (
    <a
      href="https://promo.cian.ru/sday-snimi-2/2"
      className={styles['container']}
      target="_blank"
      onClick={trackHelpDealRentTrapClick}
    >
      <Header3 as="span" color="white_100" fontWeight="bold">
        Сдай квартиру с Циан
      </Header3>
      <div className={styles['text']}>
        <Paragraph3 as="p" color="white_100" fontWeight="normal">
          Поможем найти арендатора, компенсируем любой урон квартире
        </Paragraph3>
      </div>
    </a>
  );
};

DealRentBanner.displayName = 'DealRentBanner';
